/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, runOn, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs, delegateRemove, enumGetBox, delegateCombine } from "igniteui-react-core";
import { InputGroup } from "./InputGroup";
import { Label } from "./Label";
import { Input } from "./Input";
import { Suffix } from "./Suffix";
import { Icon } from "./Icon";
import { Popup } from "igniteui-react-layouts";
import { Calendar } from "./Calendar";
import { SRProvider } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { BaseControlTheme_$type } from "igniteui-react-core";
import { DayOfWeek_$type } from "./DayOfWeek";
import { FirstWeek_$type } from "./FirstWeek";
import { DateFormats_$type } from "./DateFormats";
import { BrushUtil } from "igniteui-react-core";
import { DateTimeValueFormatter } from "./DateTimeValueFormatter";
import { ValueChangedEventArgs } from "./ValueChangedEventArgs";
import { GotFocusEventArgs } from "./GotFocusEventArgs";
import { LostFocusEventArgs } from "./LostFocusEventArgs";
import { DatePickerVisualModelExport } from "./DatePickerVisualModelExport";
import { FontUtil } from "igniteui-react-core";
import { dateMinValue, dateMaxValue, dateGetDate, dateFromValues, dateGetMonth } from "igniteui-react-core";
import { stringContains, stringIsNullOrWhiteSpace } from "igniteui-react-core";
import { stringSplit } from "igniteui-react-core";
import { isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var DatePickerView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DatePickerView, _super);
    function DatePickerView() {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.c = null;
        _this.j = null;
        _this.d = null;
        _this.l = null;
        _this.k = null;
        _this.i = null;
        _this.f = null;
        _this.e = null;
        _this.h = null;
        _this.g = null;
        return _this;
    }
    DatePickerView.prototype.ae = function () {
    };
    DatePickerView.prototype.ad = function (a) {
        if (a == null) {
            this.c = null;
            return;
        }
        this.c = a;
        var b = Math.round(a.rootWrapper.width());
        var c = Math.round(a.rootWrapper.height());
        this.x();
        this.y();
        var d = this.c.rootWrapper.getChildAt(0);
        d.listen("keydown", runOn(this, this.v));
        d.listen("focusin", runOn(this, this.t));
        d.listen("focusout", runOn(this, this.u));
        document.addEventListener("click", runOn(this, this.z), false);
    };
    DatePickerView.prototype.x = function () {
        if (this.c != null) {
            this.j = this.c.rootWrapper.getChildAt(0);
            this.j.setAttribute("tabIndex", "0");
            this.j.setStyleProperty("display", "flex");
            this.j.setStyleProperty("height", "100%");
            this.k = this.c.createElement("div");
            this.i = this.c.createElement("div");
            this.i.setRawStyleProperty("flex-grow", "1");
            this.f = this.c.createElement("div");
            this.f.setAttribute("aria-hidden", "true");
            this.e = this.c.createElement("div");
            this.h = this.c.createElement("div");
            this.h.setAttribute("aria-hidden", "true");
            this.g = this.c.createElement("div");
            this.a.ca();
            this.i.getChildAt(0).setAttribute("aria-expanded", "fasle");
            this.i.getChildAt(0).setAttribute("aria-invalid", "false");
            this.e.setStyleProperty("height", "16px");
            this.e.setStyleProperty("width", "16px");
            this.g.setStyleProperty("height", "16px");
            this.g.setStyleProperty("width", "16px");
            this.e.listen("click", runOn(this, this.w));
            this.g.listen("click", runOn(this, this.aa));
        }
    };
    DatePickerView.prototype.ah = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.j);
            a.provideContainer(b);
        }
    };
    DatePickerView.prototype.aj = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.k);
            a.provideContainer(b);
        }
    };
    DatePickerView.prototype.ai = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.i);
            a.provideContainer(b);
        }
    };
    DatePickerView.prototype.al = function (a, b) {
        if (this.c != null) {
            var c = this.c.getSubRenderer(b);
            a.provideContainer(c);
        }
    };
    DatePickerView.prototype.ag = function (a, b) {
        if (this.c != null) {
            var c = this.c.getSubRenderer(b);
            a.provideContainer(c);
        }
    };
    DatePickerView.prototype.s = function () {
        return this.k;
    };
    DatePickerView.prototype.r = function () {
        return this.i;
    };
    DatePickerView.prototype.o = function () {
        return this.f;
    };
    DatePickerView.prototype.n = function () {
        return this.e;
    };
    DatePickerView.prototype.q = function () {
        return this.h;
    };
    DatePickerView.prototype.p = function () {
        return this.g;
    };
    DatePickerView.prototype.an = function (a) {
        if (this.i != null) {
            if (a) {
                this.i.getChildAt(0).setAttribute("aria-expanded", "true");
            }
            else {
                this.i.getChildAt(0).setAttribute("aria-expanded", "false");
            }
        }
    };
    DatePickerView.prototype.ao = function (a) {
        if (a != null && a != "") {
            this.i.getChildAt(0).setAttribute("aria-label", a);
        }
        else {
            this.i.getChildAt(0).setAttribute("aria-label", "Select a date");
        }
    };
    DatePickerView.prototype.am = function () {
        if (this.e != null) {
            if (this.a.aq == true) {
                this.e.show();
            }
            else {
                this.e.hide();
            }
        }
    };
    DatePickerView.prototype.ab = function () {
        if (this.e != null) {
            this.e.hide();
        }
    };
    DatePickerView.prototype.y = function () {
        if (this.c != null) {
            this.l = this.c.rootWrapper.getChildAt(1);
            this.d = this.c.createElement("div");
            this.d.setStyleProperty("width", "100%");
            this.d.setStyleProperty("height", "100%");
            this.d.setStyleProperty("display", "flex");
            this.a.cb();
            this.d.parent().setStyleProperty("height", "100%");
        }
    };
    DatePickerView.prototype.ak = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.l);
            a.provideRenderer(b);
        }
    };
    DatePickerView.prototype.af = function (a) {
        if (this.c != null) {
            var b = this.c.getSubRenderer(this.d);
            a.provideContainer(b);
        }
    };
    DatePickerView.prototype.m = function () {
        return this.d;
    };
    DatePickerView.prototype.w = function (a) {
        this.a.b8();
        if (this.e != null) {
            this.e.hide();
        }
    };
    DatePickerView.prototype.aa = function (a) {
        a.stopPropagation();
        this.a.cg();
    };
    DatePickerView.prototype.v = function (a) {
        var b = a.which;
        if (b == 27) {
            this.a.b9();
        }
    };
    DatePickerView.prototype.t = function (a) {
        this.a.focus();
        var b = (a.originalEvent.relatedTarget);
        if (!this.b(b)) {
            this.a.cm();
        }
    };
    DatePickerView.prototype.u = function (a) {
        this.a.cf();
        var b = (a.originalEvent.relatedTarget);
        if (!this.b(b)) {
            this.a.cn();
        }
    };
    DatePickerView.prototype.z = function (a) {
        var b = a.target;
        if (!this.b(b)) {
            this.a.b9();
        }
    };
    DatePickerView.prototype.ap = function () {
        if (this.c != null) {
            var a = this.c.rootWrapper.getNativeElement();
            var b = a.getBoundingClientRect();
            ;
            return b;
        }
        return null;
    };
    DatePickerView.prototype.b = function (a) {
        if (null == a) {
            return false;
        }
        var b = this.i.getNativeElement();
        var c = this.d.getNativeElement();
        return b.contains(a) || c.contains(a);
    };
    DatePickerView.prototype.ac = function () {
    };
    DatePickerView.$t = markType(DatePickerView, 'DatePickerView');
    return DatePickerView;
}(Base));
export { DatePickerView };
/**
 * @hidden
 */
var DatePicker = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super.call(this) || this;
        _this.l = null;
        _this.y = null;
        _this.u = null;
        _this.s = null;
        _this.v = null;
        _this.q = null;
        _this.r = null;
        _this.g = null;
        _this.a4 = "dd";
        _this.a8 = "mm";
        _this.bb = "yyyy";
        _this.a5 = "mdy";
        _this.ba = "/";
        _this.ah = false;
        _this.an = false;
        _this.am = false;
        _this.av = dateMinValue();
        _this.propertyChanged = null;
        _this.valueChanged = null;
        _this.ae = null;
        _this.ax = dateMinValue();
        _this.aw = dateMinValue();
        _this.a7 = "";
        _this.c6 = BrushUtil.g(255, 24, 29, 31);
        _this.z = null;
        _this.a9 = "";
        _this.au = dateMinValue();
        _this.at = dateMaxValue();
        _this.c = 2;
        _this.a = 1;
        _this.aa = null;
        _this.c7 = BrushUtil.g(255, 24, 29, 31);
        _this.c5 = BrushUtil.g(255, 163, 172, 184);
        _this.aj = true;
        _this.ak = false;
        _this.ag = true;
        _this.ai = true;
        _this.m = 0;
        _this.o = 0;
        _this.al = false;
        _this.e = new DateTimeValueFormatter();
        _this.h = 0;
        _this.a6 = null;
        _this.gotFocus = null;
        _this.lostFocus = null;
        _this.keyDown = null;
        _this.changing = null;
        var a = new DatePickerView();
        a.a = _this;
        _this.l = a;
        _this.l.ae();
        return _this;
    }
    DatePicker.prototype.cs = function (a, b) {
        if (this.y != null) {
            this.b9();
            this.ah = true;
        }
        this.c0();
        if (this.valueChanged != null) {
            this.valueChanged(this, ((function () {
                var $ret = new ValueChangedEventArgs();
                $ret.oldValue = a;
                $ret.newValue = b;
                return $ret;
            })()));
        }
        this.cw();
    };
    DatePicker.prototype.notifySizeChanged = function () {
        this.l.ac();
    };
    DatePicker.prototype.destroy = function () {
        if (this.g != null) {
            var a = this.g;
            a.valueChanged = delegateRemove(a.valueChanged, runOn(this, this.b6));
            var b = this.g;
            b.close = delegateRemove(b.close, runOn(this, this.b5));
        }
        this.provideContainer(null);
    };
    DatePicker.prototype.provideContainer = function (a) {
        this.l.ad(a);
    };
    Object.defineProperty(DatePicker.prototype, "af", {
        get: function () {
            if (this.ae == null) {
                this.ae = new SRProvider(this.l.c);
                this.ae.cb("Calendar");
            }
            return this.ae;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "a1", {
        get: function () {
            return this.ax;
        },
        set: function (a) {
            var b = this.ax;
            this.av = b;
            this.ax = a;
            if (+b != +(this.ax)) {
                this.cr("Value", b, this.ax);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "a0", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            var b = this.aw;
            this.aw = a;
            if (+b != +(this.aw)) {
                this.cr("Today", b, this.aw);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "bp", {
        get: function () {
            return this.a7;
        },
        set: function (a) {
            var b = this.a7;
            this.a7 = a;
            if (b != this.a7) {
                this.cr("Label", b, this.a7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "c9", {
        get: function () {
            return this.c6;
        },
        set: function (a) {
            var b = this.c6;
            this.c6 = a;
            if (b != this.c6) {
                this.cr("LabelTextColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ac", {
        get: function () {
            return this.z;
        },
        set: function (a) {
            var b = this.z;
            this.z = a;
            if (b != this.z) {
                this.cr("LabelTextStyle", b, this.z);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "bw", {
        get: function () {
            return this.a9;
        },
        set: function (a) {
            var b = this.a9;
            this.a9 = a;
            if (b != this.a9) {
                this.cr("Placeholder", b, this.a9);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "az", {
        get: function () {
            return this.au;
        },
        set: function (a) {
            var b = this.au;
            this.au = a;
            if (+b != +(this.au)) {
                this.cr("MinDate", b, this.au);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ay", {
        get: function () {
            return this.at;
        },
        set: function (a) {
            var b = this.at;
            this.at = a;
            if (+b != +(this.at)) {
                this.cr("MaxDate", b, this.at);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.cr("Density", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, this.c));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a) {
                this.cr("BaseTheme", enumGetBox(BaseControlTheme_$type, b), enumGetBox(BaseControlTheme_$type, this.a));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ad", {
        get: function () {
            return this.aa;
        },
        set: function (a) {
            var b = this.aa;
            this.aa = a;
            if (b != this.aa) {
                this.cr("TextStyle", b, this.aa);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "da", {
        get: function () {
            return this.c7;
        },
        set: function (a) {
            var b = this.c7;
            this.c7 = a;
            if (b != this.c7) {
                this.cr("TextColor", b, this.c7);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "c8", {
        get: function () {
            return this.c5;
        },
        set: function (a) {
            var b = this.c5;
            this.c5 = a;
            if (b != this.c5) {
                this.cr("IconColor", b, this.c5);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "aq", {
        get: function () {
            return this.aj;
        },
        set: function (a) {
            var b = this.aj;
            this.aj = a;
            if (b != this.aj) {
                this.cr("ShowClearButton", b, this.aj);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ar", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            var b = this.ak;
            this.ak = a;
            if (b != this.ak) {
                this.cr("ShowTodayButton", b, this.ak);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ao", {
        get: function () {
            return this.ag;
        },
        set: function (a) {
            var b = this.ag;
            this.ag = a;
            if (b != this.ag) {
                this.cr("AllowTextInput", b, this.ag);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "ap", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            var b = this.ai;
            this.ai = a;
            if (b != this.ai) {
                this.cr("OpenOnFocus", b, this.ai);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "n", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            var b = this.m;
            this.m = a;
            if (b != this.m) {
                this.cr("FirstDayOfWeek", enumGetBox(DayOfWeek_$type, b), enumGetBox(DayOfWeek_$type, this.m));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "p", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            var b = this.o;
            this.o = a;
            if (b != this.o) {
                this.cr("FirstWeekOfYear", enumGetBox(FirstWeek_$type, b), enumGetBox(FirstWeek_$type, this.o));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "as", {
        get: function () {
            return this.al;
        },
        set: function (a) {
            var b = this.al;
            this.al = a;
            if (b != this.al) {
                this.cr("ShowWeekNumbers", b, this.al);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "i", {
        get: function () {
            return this.h;
        },
        set: function (a) {
            var b = this.h;
            this.h = a;
            if (this.h != b) {
                this.cr("DateFormat", enumGetBox(DateFormats_$type, b), enumGetBox(DateFormats_$type, this.h));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "bm", {
        get: function () {
            return this.a6;
        },
        set: function (a) {
            var b = this.a6;
            this.a6 = a;
            if (b != this.a6) {
                this.cr("FormatString", b, this.a6);
            }
        },
        enumerable: true,
        configurable: true
    });
    DatePicker.prototype.cr = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.cu(a, b, c);
    };
    DatePicker.prototype.cu = function (a, b, c) {
        switch (a) {
            case "Density":
                this.cx();
                break;
            case "BaseTheme":
                this.cy();
                break;
            case "Value":
                if (+(this.a1) != +(dateMinValue())) {
                    if (dateGetDate(this.a1) < dateGetDate(this.az) || dateGetDate(this.a1) > dateGetDate(this.ay)) {
                        this.a1 = this.av;
                    }
                }
                this.cs(this.av, this.a1);
                this.av = this.a1;
                if (this.g != null) {
                    this.g.at = this.a1;
                }
                break;
            case "Label":
                if (this.v != null) {
                    this.v.text = this.bp;
                    if (this.bp != null && this.bp != "") {
                        if (!this.u.inputs.contains(this.v)) {
                            this.u.inputs.insert(0, this.v);
                        }
                    }
                    else {
                        if (this.u.inputs.contains(this.v)) {
                            this.u.inputs.remove(this.v);
                        }
                    }
                }
                break;
            case "Placeholder":
                if (this.s != null) {
                    this.s.b8 = this.bw;
                    this.l.ao(this.bw);
                }
                break;
            case "Today":
                if (this.g != null) {
                    this.g.as = this.a0;
                }
                break;
            case "MaxDate":
                if (this.g != null) {
                    var d = Base.compareSimple(this.az, this.ay);
                    if (d >= 0) {
                        this.ay = dateMaxValue();
                    }
                    this.g.aq = this.at;
                }
                if (dateGetDate(this.a1) > dateGetDate(this.ay)) {
                    this.av = dateMinValue();
                    this.a1 = dateMinValue();
                }
                break;
            case "MinDate":
                if (this.g != null) {
                    this.g.ar = this.au;
                    var e = Base.compareSimple(this.az, this.ay);
                    if (e >= 0) {
                        this.av = dateMaxValue();
                        this.g.aq = this.ay;
                    }
                }
                if (dateGetDate(this.a1) < dateGetDate(this.az)) {
                    this.av = dateMinValue();
                    this.a1 = dateMinValue();
                }
                break;
            case "TextStyle":
                this.c1();
                break;
            case "ShowClearButton":
                if (this.s != null) {
                    if (this.s.cg != "") {
                        this.l.am();
                    }
                }
                break;
            case "LabelTextColor":
            case "LabelTextStyle":
            case "TextColor":
            case "IconColor":
                this.c2();
                break;
            case "ShowTodayButton":
                if (this.g != null) {
                    this.g.z = this.ar;
                }
                break;
            case "AllowTextInput":
                if (this.s != null) {
                    this.s.disabled = !this.ao;
                }
                break;
            case "OpenOnFocus": break;
            case "DateFormat":
                this.e.j(this.i);
                this.c0();
                break;
            case "FormatString":
                this.b7();
                this.c0();
                break;
            case "FirstDayOfWeek":
                if (this.g != null) {
                    this.g.n = this.n;
                }
                break;
            case "ShowWeekNumbers":
                if (this.g != null) {
                    this.g.aa = this.as;
                }
                break;
            case "FirstWeekOfYear":
                if (this.g != null) {
                    this.g.q = this.p;
                }
                break;
        }
    };
    DatePicker.prototype.b7 = function () {
        var a = '/';
        var b = this.bm.toLowerCase();
        if (stringContains(b, "/")) {
            a = '/';
        }
        else if (stringContains(b, "-")) {
            a = '-';
        }
        else if (stringContains(b, " ")) {
            a = ' ';
        }
        else if (stringContains(b, ".")) {
            a = '.';
        }
        else if (stringContains(b, ",")) {
            a = ',';
        }
        this.ba = a.toString();
        var c = b.split(a);
        if (c.length == 3) {
            var d = "";
            for (var e = 0; e < 3; e++) {
                if (stringContains(c[e], "d")) {
                    d += "d";
                    switch (c[e]) {
                        case "d":
                            this.a4 = c[e];
                            break;
                        case "dd":
                            this.a4 = c[e];
                            break;
                        case "ddd":
                            this.a4 = c[e];
                            break;
                        case "dddd":
                            this.a4 = c[e];
                            break;
                        default:
                            this.a4 = "dd";
                            break;
                    }
                }
                else if (stringContains(c[e], "m")) {
                    d += "m";
                    switch (c[e]) {
                        case "m":
                            this.a8 = c[e];
                            break;
                        case "mm":
                            this.a8 = c[e];
                            break;
                        case "mmm":
                            this.a8 = c[e];
                            break;
                        case "mmmm":
                            this.a8 = c[e];
                            break;
                        default:
                            this.a8 = "mm";
                            break;
                    }
                    this.a8 = c[e];
                }
                else if (stringContains(c[e], "y")) {
                    d += "y";
                    switch (c[e]) {
                        case "yy":
                            this.bb = c[e];
                            break;
                        case "yyyy":
                            this.bb = c[e];
                            break;
                        default:
                            this.bb = "yyyy";
                            break;
                    }
                }
            }
            if (d == "dmy" || d == "mdy" || d == "ymd") {
                this.a5 = d;
            }
            else {
                this.a5 = "mdy";
            }
        }
    };
    DatePicker.prototype.c2 = function () {
        if (this.s != null) {
            this.s.dv = this.da;
        }
        if (this.q != null) {
            this.q.fill = this.c8;
        }
        if (this.r != null) {
            this.r.fill = this.c8;
        }
        if (this.v != null) {
            this.v.dc = this.c9;
            this.v.y = this.ac;
        }
    };
    DatePicker.prototype.cz = function () {
        if (this.u != null) {
        }
    };
    DatePicker.prototype.c1 = function () {
        if (this.aa != null) {
            this.s.ac = this.aa;
        }
    };
    DatePicker.prototype.ca = function () {
        this.u = new InputGroup();
        this.l.ah(this.u);
        this.u.k = 0;
        this.u.d = this.b;
        this.u.h = this.d;
        this.v = new Label();
        this.l.aj(this.v);
        this.v.dc = this.c9;
        this.v.y = this.ac;
        this.u.appendContentChild(this.l.s());
        if (this.bp != null && this.bp != "") {
            this.v.text = this.bp;
            this.u.inputs.add(this.v);
        }
        this.s = new Input();
        this.l.ai(this.s);
        this.s.b1 = "text";
        if (this.aa != null) {
            this.s.ac = this.aa;
        }
        this.s.disabled = !this.ao;
        this.s.dv = this.da;
        this.u.appendContentChild(this.l.r());
        this.u.inputs.add(this.s);
        this.s.b8 = this.bw;
        this.l.ao(this.bw);
        var a = this.s;
        a.change = delegateCombine(a.change, runOn(this, this.ch));
        var b = this.s;
        b.changing = delegateCombine(b.changing, runOn(this, this.ci));
        var c = this.s;
        c.keyDown = delegateCombine(c.keyDown, runOn(this, this.cj));
        var d = new Suffix();
        this.l.al(d, this.l.o());
        this.q = new Icon();
        this.l.ag(this.q, this.l.n());
        this.q.svgPath = DatePicker.bf;
        this.q.fill = this.c8;
        d.appendContentChild(this.l.n());
        this.u.appendContentChild(this.l.o());
        this.u.inputs.add(d);
        this.c0();
        var e = new Suffix();
        this.l.al(e, this.l.q());
        this.r = new Icon();
        this.l.ag(this.r, this.l.p());
        this.r.svgPath = DatePicker.be;
        this.r.fill = this.c8;
        e.appendContentChild(this.l.p());
        this.u.appendContentChild(this.l.q());
        this.u.inputs.add(e);
    };
    DatePicker.prototype.cj = function (a, b) {
        this.cp(b);
        if (b.defaultPrevented) {
            return;
        }
        var c = b.keyCode;
        var d = b.modifiers;
        switch (c) {
            case 9:
                this.am = true;
                if (!this.an) {
                    this.c4(this.s.cg);
                }
                this.b9();
                this.ah = true;
                this.am = false;
                break;
            case 13:
                this.am = true;
                if (!this.an) {
                    this.c4(this.s.cg);
                }
                this.b9();
                this.ah = true;
                this.am = false;
                break;
            case 40:
                if (d == 1) {
                    this.ct();
                    this.ce();
                }
                break;
            case 38:
                if (d == 1) {
                    this.b9();
                }
                break;
        }
    };
    DatePicker.prototype.ci = function (a, b) {
        this.cl(b);
        if (b.value.length > 0) {
            this.l.am();
        }
        else {
            this.l.ab();
        }
    };
    DatePicker.prototype.ch = function (a, b) {
        this.an = true;
        this.c4(b.value);
        this.an = false;
    };
    DatePicker.prototype.c4 = function (a) {
        var b = ['/', '-', ' ', '.', ','];
        var c = stringSplit(a, b, 1);
        var d = 0;
        var e = 0;
        var f = 0;
        var g = true;
        if (c.length == 3) {
            if (c[0].length == 0 || c[1].length == 0 || c[2].length == 0) {
                g = false;
            }
            if (this.a5 == "dmy") {
                d = parseInt(c[0]);
                e = parseInt(c[1]);
                f = parseInt(c[2]);
            }
            else if (this.a5 == "mdy") {
                e = parseInt(c[0]);
                d = parseInt(c[1]);
                f = parseInt(c[2]);
            }
            else if (this.a5 == "ymd") {
                f = parseInt(c[0]);
                e = parseInt(c[1]);
                d = parseInt(c[2]);
            }
            if (isNaN_(d) || isNaN_(f)) {
                g = false;
            }
            if (f < 50) {
                f = f + 2000;
            }
            if (isNaN_(e)) {
                var h = "";
                if (this.a5 == "dmy") {
                    h = c[1].toLowerCase();
                }
                else if (this.a5 == "mdy") {
                    h = c[0].toLowerCase();
                }
                else if (this.a5 == "ymd") {
                    h = c[1].toLowerCase();
                }
                var i = !stringIsNullOrWhiteSpace(this.af.b1("January_Full")) ? this.af.b1("January_Full").toLowerCase() : "january";
                var j = !stringIsNullOrWhiteSpace(this.af.b1("January_Short")) ? this.af.b1("January_Short").toLowerCase() : "jan";
                var k = !stringIsNullOrWhiteSpace(this.af.b1("February_Full")) ? this.af.b1("February_Full").toLowerCase() : "february";
                var l = !stringIsNullOrWhiteSpace(this.af.b1("February_Short")) ? this.af.b1("February_Short").toLowerCase() : "feb";
                var m = !stringIsNullOrWhiteSpace(this.af.b1("March_Full")) ? this.af.b1("March_Full").toLowerCase() : "march";
                var n = !stringIsNullOrWhiteSpace(this.af.b1("March_Short")) ? this.af.b1("March_Short").toLowerCase() : "mar";
                var o = !stringIsNullOrWhiteSpace(this.af.b1("April_Full")) ? this.af.b1("April_Full").toLowerCase() : "april";
                var p = !stringIsNullOrWhiteSpace(this.af.b1("April_Short")) ? this.af.b1("April_Short").toLowerCase() : "apr";
                var q = !stringIsNullOrWhiteSpace(this.af.b1("May_Full")) ? this.af.b1("May_Full").toLowerCase() : "may";
                var r = !stringIsNullOrWhiteSpace(this.af.b1("May_Short")) ? this.af.b1("May_Short").toLowerCase() : "may";
                var s = !stringIsNullOrWhiteSpace(this.af.b1("June_Full")) ? this.af.b1("June_Full").toLowerCase() : "june";
                var t = !stringIsNullOrWhiteSpace(this.af.b1("June_Short")) ? this.af.b1("June_Short").toLowerCase() : "jun";
                var u = !stringIsNullOrWhiteSpace(this.af.b1("July_Full")) ? this.af.b1("July_Full").toLowerCase() : "july";
                var v = !stringIsNullOrWhiteSpace(this.af.b1("July_Short")) ? this.af.b1("July_Short").toLowerCase() : "jul";
                var w = !stringIsNullOrWhiteSpace(this.af.b1("August_Full")) ? this.af.b1("August_Full").toLowerCase() : "august";
                var x = !stringIsNullOrWhiteSpace(this.af.b1("August_Short")) ? this.af.b1("August_Short").toLowerCase() : "aug";
                var y = !stringIsNullOrWhiteSpace(this.af.b1("September_Full")) ? this.af.b1("September_Full").toLowerCase() : "september";
                var z = !stringIsNullOrWhiteSpace(this.af.b1("September_Short")) ? this.af.b1("September_Short").toLowerCase() : "sep";
                var aa = !stringIsNullOrWhiteSpace(this.af.b1("October_Full")) ? this.af.b1("October_Full").toLowerCase() : "october";
                var ab = !stringIsNullOrWhiteSpace(this.af.b1("October_Short")) ? this.af.b1("October_Short").toLowerCase() : "oct";
                var ac = !stringIsNullOrWhiteSpace(this.af.b1("November_Full")) ? this.af.b1("November_Full").toLowerCase() : "november";
                var ad = !stringIsNullOrWhiteSpace(this.af.b1("November_Short")) ? this.af.b1("November_Short").toLowerCase() : "nov";
                var ae = !stringIsNullOrWhiteSpace(this.af.b1("December_Full")) ? this.af.b1("December_Full").toLowerCase() : "december";
                var af = !stringIsNullOrWhiteSpace(this.af.b1("December_Short")) ? this.af.b1("December_Short").toLowerCase() : "dec";
                if (h == i || h == j) {
                    e = 1;
                }
                else if (h == k || h == l) {
                    e = 2;
                }
                else if (h == m || h == n) {
                    e = 3;
                }
                else if (h == o || h == p) {
                    e = 4;
                }
                else if (h == q || h == r) {
                    e = 5;
                }
                else if (h == s || h == t) {
                    e = 6;
                }
                else if (h == u || h == v) {
                    e = 7;
                }
                else if (h == w || h == x) {
                    e = 8;
                }
                else if (h == y || h == z) {
                    e = 9;
                }
                else if (h == aa || h == ab) {
                    e = 10;
                }
                else if (h == ac || h == ad) {
                    e = 11;
                }
                else if (h == ae || h == af) {
                    e = 12;
                }
                else {
                    g = false;
                }
            }
            if (e > 12 || e < 1) {
                g = false;
            }
        }
        else {
            g = false;
        }
        if (g) {
            var ag = dateFromValues(f, e, d, 0, 0, 0, 0);
            var ah = Base.compareSimple(ag, this.az);
            var ai = Base.compareSimple(ag, this.ay);
            if (ah < 0 || ai > 0) {
                this.c0();
            }
            else {
                this.c3(ag);
                this.l.am();
            }
        }
        else {
            this.c0();
        }
    };
    DatePicker.prototype.c3 = function (a) {
        var b = this.a1;
        this.a1 = a;
    };
    DatePicker.prototype.c0 = function () {
        if (this.s != null) {
            if (+(this.ax) != +(dateMinValue())) {
                var a = "";
                if (this.bm == null) {
                    a = this.e.i(this.a1);
                }
                else {
                    var b = this.a1.getDate().toString();
                    var c = b;
                    if (this.a4 == "dd") {
                        if (this.a1.getDate() < 10) {
                            b = "0" + b;
                        }
                    }
                    else if (this.a4 == "ddd") {
                        switch (this.a1.getDay()) {
                            case 0:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Sunday_Short")) ? this.af.b1("Sunday_Short") : "Sun";
                                break;
                            case 1:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Monday_Short")) ? this.af.b1("Monday_Short") : "Mon";
                                break;
                            case 2:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Tuesday_Short")) ? this.af.b1("Tuesday_Short") : "Tue";
                                break;
                            case 3:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Wednesday_Short")) ? this.af.b1("Wednesday_Short") : "Wed";
                                break;
                            case 4:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Thursday_Short")) ? this.af.b1("Thursday_Short") : "Thu";
                                break;
                            case 5:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Friday_Short")) ? this.af.b1("Friday_Short") : "Fri";
                                break;
                            case 6:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Saturday_Short")) ? this.af.b1("Saturday_Short") : "Sat";
                                break;
                        }
                    }
                    else if (this.a4 == "dddd") {
                        switch (this.a1.getDay()) {
                            case 0:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Sunday_Full")) ? this.af.b1("Sunday_Full") : "Sunday";
                                break;
                            case 1:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Monday_Full")) ? this.af.b1("Monday_Full") : "Monday";
                                break;
                            case 2:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Tuesday_Full")) ? this.af.b1("Tuesday_Full") : "Tuesday";
                                break;
                            case 3:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Wednesday_Full")) ? this.af.b1("Wednesday_Full") : "Wednesday";
                                break;
                            case 4:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Thursday_Full")) ? this.af.b1("Thursday_Full") : "Thursday";
                                break;
                            case 5:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Friday_Full")) ? this.af.b1("Friday_Full") : "Friday";
                                break;
                            case 6:
                                b = !stringIsNullOrWhiteSpace(this.af.b1("Saturday_Full")) ? this.af.b1("Saturday_Full") : "Saturday";
                                break;
                        }
                    }
                    var d = dateGetMonth(this.a1).toString();
                    if (this.a8 == "mm") {
                        if (dateGetMonth(this.a1) < 10) {
                            d = "0" + d;
                        }
                    }
                    else if (this.a8 == "mmm") {
                        switch (dateGetMonth(this.a1)) {
                            case 1:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("January_Short")) ? this.af.b1("January_Short") : "Jan";
                                break;
                            case 2:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("February_Short")) ? this.af.b1("February_Short") : "Feb";
                                break;
                            case 3:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("March_Short")) ? this.af.b1("March_Short") : "Mar";
                                break;
                            case 4:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("April_Short")) ? this.af.b1("April_Short") : "Apr";
                                break;
                            case 5:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("May_Short")) ? this.af.b1("May_Short") : "May";
                                break;
                            case 6:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("June_Short")) ? this.af.b1("June_Short") : "Jun";
                                break;
                            case 7:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("July_Short")) ? this.af.b1("July_Short") : "Jul";
                                break;
                            case 8:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("August_Short")) ? this.af.b1("August_Short") : "Aug";
                                break;
                            case 9:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("September_Short")) ? this.af.b1("September_Short") : "Sep";
                                break;
                            case 10:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("October_Short")) ? this.af.b1("October_Short") : "Oct";
                                break;
                            case 11:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("November_Short")) ? this.af.b1("November_Short") : "Nov";
                                break;
                            case 12:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("December_Short")) ? this.af.b1("December_Short") : "Dec";
                                break;
                        }
                    }
                    else if (this.a8 == "mmmm") {
                        switch (dateGetMonth(this.a1)) {
                            case 1:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("January_Full")) ? this.af.b1("January_Full") : "January";
                                break;
                            case 2:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("February_Full")) ? this.af.b1("February_Full") : "February";
                                break;
                            case 3:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("March_Full")) ? this.af.b1("March_Full") : "March";
                                break;
                            case 4:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("April_Full")) ? this.af.b1("April_Full") : "April";
                                break;
                            case 5:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("May_Full")) ? this.af.b1("May_Full") : "May";
                                break;
                            case 6:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("June_Full")) ? this.af.b1("June_Full") : "June";
                                break;
                            case 7:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("July_Full")) ? this.af.b1("July_Full") : "July";
                                break;
                            case 8:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("August_Full")) ? this.af.b1("August_Full") : "August";
                                break;
                            case 9:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("September_Full")) ? this.af.b1("September_Full") : "September";
                                break;
                            case 10:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("October_Full")) ? this.af.b1("October_Full") : "October";
                                break;
                            case 11:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("November_Full")) ? this.af.b1("November_Full") : "November";
                                break;
                            case 12:
                                d = !stringIsNullOrWhiteSpace(this.af.b1("December_Full")) ? this.af.b1("December_Full") : "December";
                                break;
                        }
                    }
                    var e = this.a1.getFullYear().toString();
                    if (this.bb == "yy") {
                        e = e.substr(2);
                    }
                    if (this.a5 == "dmy") {
                        if (this.a4 == "ddd" || this.a4 == "dddd") {
                            a = b + this.ba + d + " " + c + this.ba + e;
                        }
                        else {
                            a = b + this.ba + d + this.ba + e;
                        }
                    }
                    else if (this.a5 == "mdy") {
                        if (this.a4 == "ddd" || this.a4 == "dddd") {
                            a = d + " " + c + this.ba + b + this.ba + e;
                        }
                        else {
                            a = d + this.ba + b + this.ba + e;
                        }
                    }
                    else if (this.a5 == "ymd") {
                        if (this.a4 == "ddd" || this.a4 == "dddd") {
                            a = e + this.ba + d + " " + c + this.ba + b;
                        }
                        else {
                            a = e + this.ba + d + this.ba + b;
                        }
                    }
                }
                this.s.cg = a;
                this.l.am();
            }
            else {
                this.s.cg = "";
                this.l.ab();
            }
        }
    };
    DatePicker.prototype.b8 = function () {
        if (this.s != null) {
            this.s.cg = "";
        }
        this.a1 = dateMinValue();
        this.g.cg();
    };
    DatePicker.prototype.cb = function () {
        this.y = new Popup();
        this.l.ak(this.y);
        this.g = new Calendar();
        this.l.af(this.g);
        if (+(this.az) != +(dateMinValue())) {
            this.g.ar = this.az;
        }
        if (+(this.ay) != +(dateMaxValue())) {
            this.g.aq = this.ay;
        }
        if (+(this.a0) != +(dateMinValue())) {
            this.g.as = this.a0;
        }
        this.g.z = this.ar;
        this.g.n = this.n;
        this.g.aa = this.as;
        this.g.q = this.p;
        var a = this.g;
        a.valueChanged = delegateCombine(a.valueChanged, runOn(this, this.b6));
        var b = this.g;
        b.close = delegateCombine(b.close, runOn(this, this.b5));
        this.y.appendPopupContent(this.l.m());
    };
    DatePicker.prototype.b6 = function (a, b) {
        this.a1 = b.newValue;
    };
    DatePicker.prototype.b5 = function (a) {
        if (this.y.t) {
            this.b9();
            this.ah = true;
        }
    };
    DatePicker.prototype.cg = function () {
        if (this.ah == false) {
            if (this.y.t) {
                this.b9();
            }
            else {
                this.ct();
            }
        }
        else {
            this.ah = false;
        }
    };
    DatePicker.prototype.ct = function () {
        var a = this.l.ap();
        if (this.y != null) {
            this.y.showRelativeToExclusionRect(a, 0, 0);
        }
        this.l.an(true);
    };
    DatePicker.prototype.b9 = function () {
        if (this.y != null) {
            this.y.ao();
        }
        if (this.g != null) {
            this.g.cr();
        }
        this.l.an(false);
        this.ah = false;
    };
    DatePicker.prototype.focus = function () {
        var _this = this;
        if (this.s != null) {
            this.s.focus();
        }
        if (!this.y.t) {
            if (this.ah == false) {
                if (this.ao == false) {
                    this.ct();
                    this.ah = true;
                    window.setTimeout(function () { return _this.ce(); }, 0);
                }
                else {
                    if (this.ap == true && this.am == false) {
                        this.ct();
                        this.ah = true;
                        window.setTimeout(function () { return _this.ce(); }, 0);
                    }
                }
            }
            else {
                this.ah = false;
            }
        }
    };
    DatePicker.prototype.cf = function () {
    };
    DatePicker.prototype.cw = function () {
        if (this.s != null) {
            this.s.dd();
        }
    };
    DatePicker.prototype.ce = function () {
        this.g.cj();
    };
    DatePicker.prototype.cm = function () {
        var a = new GotFocusEventArgs();
        this.co(a);
    };
    DatePicker.prototype.cn = function () {
        var a = new LostFocusEventArgs();
        this.cq(a);
    };
    DatePicker.prototype.cy = function () {
    };
    DatePicker.prototype.cx = function () {
    };
    DatePicker.prototype.a3 = function () {
        return this.f();
    };
    DatePicker.prototype.bj = function () {
        var a = this.f();
        return a.g();
    };
    DatePicker.prototype.f = function () {
        var a = new DatePickerVisualModelExport();
        a.b = this.d;
        a.a = this.b;
        a.e = this.y.ab();
        a.d = this.u.ia();
        a.c = this.g.bg();
        if (this.ad != null) {
            var b = this.ad;
            if (this.l != null && b.n == null) {
                var c = this.l.c;
                var d = FontUtil.getFontInfoFromString(c, b.fontString);
                b.n = d.n;
                b.d = d.d;
                b.o = d.o;
                b.q = d.q;
                b.r = d.r;
                b.s = d.s;
            }
            if (b.n != null) {
                a.h = b.n;
            }
            if (!isNaN_(b.d)) {
                a.f = b.d;
            }
            if (b.s != null) {
                a.l = b.s;
            }
            if (b.q != null) {
                a.j = b.q;
            }
            if (b.o != null) {
                a.i = b.q;
            }
        }
        return a;
    };
    DatePicker.prototype.co = function (a) {
        if (null != this.gotFocus) {
            this.gotFocus(this, a);
        }
    };
    DatePicker.prototype.cq = function (a) {
        if (null != this.lostFocus) {
            this.lostFocus(this, a);
        }
    };
    DatePicker.prototype.cp = function (a) {
        if (null != this.keyDown) {
            this.keyDown(this, a);
        }
    };
    DatePicker.prototype.cl = function (a) {
        if (null != this.changing) {
            this.changing(this, a);
        }
    };
    DatePicker.$t = markType(DatePicker, 'DatePicker', Base.$, [INotifyPropertyChanged_$type]);
    DatePicker.be = "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z";
    DatePicker.bf = "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z";
    DatePicker.ab = null;
    return DatePicker;
}(Base));
export { DatePicker };
//# sourceMappingURL=DatePickerView_combined.js.map
